import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: flex-end;
`
